/**
 * @generated SignedSource<<31f10353859627781c51c4c43c2989f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ScormCompletionStatus = "completed" | "failed" | "incomplete" | "not_attempted" | "passed" | "%future added value";
export type UpdateScormCompletionInput = {
  scormCompletionId: string;
  scormData: string;
  scormFileId?: string | null;
};
export type EditorScormEmbed_updateScormCompletionMutation$variables = {
  input: UpdateScormCompletionInput;
};
export type EditorScormEmbed_updateScormCompletionMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly contentUsage: {
        readonly id: string;
        readonly viewerScormCompletion: {
          readonly id: string;
          readonly status: ScormCompletionStatus;
        } | null;
      } | null;
      readonly id: string;
      readonly scormData: string;
      readonly status: ScormCompletionStatus;
    } | null;
  };
};
export type EditorScormEmbed_updateScormCompletionMutation = {
  response: EditorScormEmbed_updateScormCompletionMutation$data;
  variables: EditorScormEmbed_updateScormCompletionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateScormCompletionResponse",
    "kind": "LinkedField",
    "name": "updateScormCompletion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ScormCompletion",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scormData",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentUsage",
            "kind": "LinkedField",
            "name": "contentUsage",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ScormCompletion",
                "kind": "LinkedField",
                "name": "viewerScormCompletion",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditorScormEmbed_updateScormCompletionMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorScormEmbed_updateScormCompletionMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "47ebba2663aeb2bb927de689d6e28aef",
    "id": null,
    "metadata": {},
    "name": "EditorScormEmbed_updateScormCompletionMutation",
    "operationKind": "mutation",
    "text": "mutation EditorScormEmbed_updateScormCompletionMutation(\n  $input: UpdateScormCompletionInput!\n) {\n  response: updateScormCompletion(input: $input) {\n    node {\n      id\n      scormData\n      status\n      contentUsage {\n        id\n        viewerScormCompletion {\n          id\n          status\n        }\n      }\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4cb05b4e7170f8d575ef4750574a7f17";

export default node;
